import { ReactElement, useMemo } from 'react'
import { ItemSchema, OptionSchema } from '../../ajax'
import { FormInstance } from 'antd-mobile/es/components/form'
import { Checkbox, Form, Input, Radio } from 'antd-mobile'
import style from './index.module.less'
import classNames from 'classnames'
const { Item } = Form

function formatLabel (s: string): ReactElement {
  const l = s.split('\\n')
  return (
    <>
      {l.map((li, i) => {
        return <div key={i}>{li}</div>
      })}
    </>
  )
}

function renderItem (data: OptionSchema, isInput: boolean, isRadio: boolean, i: number, j: number, formRef: FormInstance): any {
  const hasPlaceholder = typeof data.placeholder === 'string' && data.placeholder.length > 0
  const Com = isRadio ? Radio : Checkbox
  if (isInput) {
    return (
      <div className={style.option}>
        <Item name={['items', i, 'options', j, 'config_optionid']} noStyle><span /></Item>
        <Item name={['items', i, 'options', j, 'placeholder']} noStyle><span /></Item>
        <Item name={['items', i, 'options', j, 'checked']} noStyle><span /></Item>
        <Item name={['items', i, 'options', j, 'orderno']} noStyle><span /></Item>
        <Item name={['items', i, 'options', j, 'result']} noStyle>
          <Input placeholder={hasPlaceholder ? data.placeholder : '请输入'} />
        </Item>
      </div>
    )
  }
  return (
    <div className={style['option-select']}>
      <Item name={['items', i, 'options', j, 'config_optionid']} noStyle><span /></Item>
      <Item name={['items', i, 'options', j, 'title']} noStyle><span /></Item>
      <Item name={['items', i, 'options', j, 'placeholder']} noStyle><span /></Item>
      <Item name={['items', i, 'options', j, 'isext']} noStyle><span /></Item>
      <Item name={['items', i, 'options', j, 'isdefault']} noStyle><span /></Item>
      <Item name={['items', i, 'options', j, 'tooltip']} noStyle><span /></Item>
      <Item name={['items', i, 'options', j, 'orderno']} noStyle><span /></Item>
      <Item name={['items', i, 'options', j, 'checked']} noStyle valuePropName='checked'>
        <Com
          onChange={() => {
            if (isRadio) {
              const d = JSON.parse(JSON.stringify(formRef.getFieldValue('items')))
              const l: OptionSchema[] = d[i].options
              for (let n = 0; n < l.length; n++) {
                l[n].checked = false
              }
              l[j].checked = true
              formRef.setFieldsValue({ items: d })
            }
          }}
        >
          {formatLabel(data.title)}
        </Com>
      </Item>
    </div>
  )
}

interface Props {
  data: ItemSchema
  i: number
  formRef: FormInstance
}

function Main ({ data, i, formRef }: Props): ReactElement {
  const isInput = useMemo(() => {
    return data.type === '填空'
  }, [data])
  const isRadio = useMemo(() => {
    return data.type === '单选'
  }, [data])
  const options = useMemo(() => {
    const l = data.options !== null && data.options instanceof Array ? data.options : []
    return l
  }, [data])
  return (
    <div className={style.container}>
      <div className={style.header}>
        <span className={classNames(style.title, { [style.required]: data.required === 1 })}>
          <span>{i + 1}、</span>
          <span>{data.title}</span>
        </span>
      </div>
      <Item name={['items', i, 'title']} noStyle><span /></Item>
      <Item name={['items', i, 'type']} noStyle><span /></Item>
      <Item name={['items', i, 'config_itemid']} noStyle><span /></Item>
      <Item name={['items', i, 'config_item_groupid']} noStyle><span /></Item>
      <Item name={['items', i, 'required']} noStyle><span /></Item>
      <div className={style.body}>
          {
            options.map((li, j) => {
              return (
                <div className={style['body-inner']} key={`${li.id}${i}${j}`}>
                  {renderItem(li, isInput, isRadio, i, j, formRef)}
                </div>
              )
            })
          }
        </div>
    </div>
  )
}

export default Main
